import { ComponentProps } from 'react';

/*
 * Marca da Apple em `currentColor`: as diretrizes da Apple exigem o logo em
 * preto ou branco sólido, então ele acompanha a cor do texto do botão em vez de
 * ter cor própria — diferente do GoogleIcon, que é multicolorido por definição.
 */
function AppleIcon(props: ComponentProps<'svg'>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      {...props}
    >
      <path
        d='M17.44 13.66C17.47 16.60 20.03 17.59 20.07 17.60C20.04 17.66 19.66 19.01 18.71 20.39C17.89 21.59 17.05 22.78 15.70 22.81C14.38 22.83 13.96 22.03 12.45 22.03C10.94 22.03 10.47 22.78 9.23 22.83C7.93 22.89 6.95 21.54 6.13 20.35C4.34 17.75 2.97 13.00 4.81 9.79C5.72 8.20 7.36 7.19 9.12 7.17C10.40 7.14 11.61 8.02 12.37 8.02C13.14 8.02 14.61 6.96 16.14 7.12C16.78 7.14 18.58 7.35 19.73 8.87C19.64 8.93 17.58 10.12 17.61 12.62L18.08 13.66L17.44 13.66ZM14.69 4.26C15.37 3.44 15.83 2.30 15.70 1.16C14.70 1.20 13.49 1.83 12.77 2.66C12.13 3.39 11.57 4.56 11.72 5.67C12.83 5.76 13.97 5.11 14.69 4.26L14.69 4.26Z'
        fill='currentColor'
      />
    </svg>
  );
}

export { AppleIcon };
